'use client'
import React, { useEffect, useRef, useState } from "react";
import SvgIcons from "./SvgIcons";
import FacebookLoginForm from "./FacebookLoginForm";
import { useRouter } from 'next/navigation'
import './LoginLogoutMenu.css';
import { UserModel } from "@/db/schema";


export interface LoginLogoutMenuProps {
    profile?: UserModel | undefined | null;
    logIn: (service?: string | null, data?: object | string | null, redirect?: string | null) => void;
    logOut: () => void;
    footer?: boolean;
}

const LoginLogoutMenu: React.FC<LoginLogoutMenuProps> = ({ profile, logIn, logOut, footer = false }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const router = useRouter()

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
          if (!ref.current?.contains(event.target as Node)) {
            const el = ref?.current;

            if (!el || el.contains(event.target as Node)) {
              return;
            }

            setIsOpen(false);
          }
        };

        window?.addEventListener("click", handleClick, { capture: true });

        return () => {
            window?.removeEventListener("click", handleClick, { capture: true });
        };
      }, [ref]);

    const toggle = () => {
        setIsOpen(old => !old);
    }

    const transitionClass = isOpen ? "flex" : "hidden";

    const { PersonIcon, GoogleIcon, DiscordIcon, GameControllerIcon, ExitIcon, FacebookIcon } = SvgIcons();


    return (
        <div className={footer ? 'footerUserMenuContainer' : 'relative'} ref={ref}>
            <button
                id="login-logout-menu-button"
                onClick={toggle}
                // style={{ padding: 0, margin: 0, minWidth: 0, color: '#FFF' }}
            >
                { profile && (profile.avatar || profile.picture) ?
                    <img src={profile.avatar ?? profile.picture ?? ''} alt="theuser" className={`${footer ? 'footerUserMenu' : ''} theLoggedInUser cursor-pointer hover:opacity-75`} />
                    :
                    <PersonIcon width={footer ? '20px' : '32px'}  height={footer ? '20px' : '32px'} className={`${footer ? 'footerUserMenu' : ''} theLoggedOutUser cursor-pointer hover:opacity-75`} />
                }
            </button>
            <div id="login-logout-menu" className={`absolute ${footer ? 'bottom-6' : 'top-10  min-h-25'} w-62.5 overflow-hidden right-2 z-30 flex flex-col py-0 bg-gray-900 rounded-lg shadow-xl ${transitionClass}`}>
                { profile ?
                    <>
                        <div onClick={() => { router.push("/profile"); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><PersonIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">Profile</span>
                        </div>
                        <hr className="h-0.5 border-t-0 bg-white/10" />
                        <div onClick={() => { router.push("/games/history"); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><GameControllerIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">My Games</span>
                        </div>
                        <hr className="h-0.5 border-t-0 bg-white/10" />
                        <div onClick={() => { logOut(); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><ExitIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">Logout</span>
                        </div>
                    </>
                    :
                    <>
                        <div onClick={() => { logIn(); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><GoogleIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">Sign in with Google</span>
                        </div>
                        <hr className="h-0.5 border-t-0 bg-white/10" />
                        <div onClick={() => { logIn('discord', null, window.location.href); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><DiscordIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">Sign in with Discord</span>
                        </div>
                        <hr className="h-0.5 border-t-0 bg-white/10" />
                        <FacebookLoginForm handleClose={() => setIsOpen(false)} logIn={(service: string | null, data?: object | string | null) => logIn(service, data)}/>
                        <hr className="h-0.5 border-t-0 bg-white/10" />
                        {/* <div onClick={() => { logIn('facebookoauth2', null, window.location.href); setIsOpen(false); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                            <span className="col-span-2"><FacebookIcon width="22px" height="22px" /></span>
                            <span className="col-span-10">Facebook Oauth2</span>
                        </div>
                        <hr className="h-0.5 border-t-0 bg-white/10" /> */}
                        <div onClick={() => { logIn('orca'); setIsOpen(false); }} className="px-5 pt-3 pb-4 grid grid-cols-12 cursor-pointer hover:bg-sky-900 items-center">
                            <span className="col-span-2"><img src="/assets/image/orca_logo_128x80.png" width="22px" height="22px" alt="ORCA" /></span>
                            <span className="col-span-10">Sign in with ORCA</span>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default LoginLogoutMenu;
